import { Card, CardFooter, CardHeader } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export function ProductSkeleton() {
  return (
    <Card className="overflow-hidden">
      <div className="aspect-square overflow-hidden bg-card">
        <Skeleton className="w-full h-full" />
      </div>
      <CardHeader>
        <Skeleton className="h-5 w-3/4 mb-2" />
        <Skeleton className="h-4 w-full" />
      </CardHeader>
      <CardFooter className="flex items-center justify-between">
        <Skeleton className="h-6 w-20" />
        <Skeleton className="h-9 w-24" />
      </CardFooter>
    </Card>
  )
}

export function ProductGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  )
}

// Skeleton for OurMenuScreen layout
export function MenuScreenSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[250px_1fr] gap-8 lg:gap-12">
      {/* Category Sidebar Skeleton */}
      <aside className="lg:sticky lg:top-8 h-fit">
        <div className="space-y-2">
          {Array.from({ length: 7 }).map((_, index) => (
            <Skeleton key={index} className="w-full h-12 rounded-lg" />
          ))}
        </div>
      </aside>

      {/* Products Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center space-y-4"
          >
            {/* Circular Image Skeleton */}
            <Skeleton className="w-48 h-48 rounded-full border-4 border-orange-500/20" />

            {/* Product Info Skeleton */}
            <div className="space-y-2 w-full">
              {/* Product Name */}
              <Skeleton className="h-6 w-3/4 mx-auto" />

              {/* Star Rating Skeleton */}
              <div className="flex items-center justify-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Skeleton key={i} className="h-4 w-4 rounded-full" />
                ))}
              </div>

              {/* Price Skeleton */}
              <Skeleton className="h-8 w-24 mx-auto" />

              {/* Button Skeleton */}
              <Skeleton className="h-12 w-full rounded-md" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

// Skeleton for HomeScreen menu section (circular items without sidebar)
export function HomeMenuSkeleton({ count = 15 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center space-y-4"
        >
          {/* Circular Image Skeleton */}
          <Skeleton className="w-48 h-48 rounded-full border-4 border-orange-500/20" />

          {/* Product Info Skeleton */}
          <div className="space-y-2 w-full">
            {/* Product Name */}
            <Skeleton className="h-6 w-3/4 mx-auto" />

            {/* Star Rating Skeleton */}
            <div className="flex items-center justify-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-4 w-4 rounded-full" />
              ))}
            </div>

            {/* Price Skeleton */}
            <Skeleton className="h-8 w-24 mx-auto" />

            {/* Button Skeleton */}
            <Skeleton className="h-12 w-32 mx-auto rounded-md" />
          </div>
        </div>
      ))}
    </div>
  )
}

